import CustomModal from 'components/CustomModal';
import { toastMessageBox } from 'components/ToastifyMessage';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import DeleteConfirm from 'components/dialogBoxes/DeleteConfirm';
import SelectOption from 'components/select/SelectOption';
import { getDrpResolutionStatus } from 'functions/dropdowns';
import { closeTicket, getTicketMasterCon } from 'functions/ticket';
import { active_inative } from 'functions/client';
import React, { useEffect, useState } from 'react';
import { Card, Dropdown, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const TicketsPreviewHeader = ({ ticketMasterId, companyMasterId1, isAccepted, assignedAgent, currentUserName }) => {
  const navigate = useNavigate();

  const [selectedResolutionStatus, setSelectedResolutionStatus] = React.useState(0);
  const [resolutionStatus, setResolutionStatus] = React.useState(false);
  const [remarks, setRemarks] = useState('');
  const [showBanConfirm, setShowBanConfirm] = useState(false);
  const [banIdToDelete, setBanIdToDelete] = useState(null);
  const [companyMasterId, setCompanyMasterId] = useState(null);

  // Loading states
  const [isClosing, setIsClosing] = useState(false);
  const [isBanning, setIsBanning] = useState(false);

  console.log('ticketMasterId', ticketMasterId);
  console.log('companyMasterId1 (prop):', companyMasterId1);
  console.log('companyMasterId (state):', companyMasterId);

  const cancelCloseHandler = async () => {
    setShowDeleteConfirm(false);
    setIdToDelete(null);
    console.log('Cancelled!');
  };

  const closeHandler = async () => {
    setShowDeleteConfirm(true);
    console.log('Cancelled!');
  };

  const confirmCloseHandler = async () => {
    // Validation
    if (!selectedResolutionStatus || selectedResolutionStatus === 0 || selectedResolutionStatus === '') {
      toastMessageBox("Validation Error", "Please select a resolution status", "warning");
      return;
    }

    try {
      setIsClosing(true); // Start loading

      const data = {
        ticketMasterId: idToDelete,
        remark: remarks,
        resolutionStatusId: selectedResolutionStatus
      };

      console.log('Closing ticket with data:', data);
      const token = localStorage.getItem('token');
      const res = await closeTicket(data, token);

      // Log the entire response to see structure
      console.log('Full closeTicket response:', res);
      console.log('res.data:', res.data);

      // Check if response exists
      if (!res || !res.data) {
        toastMessageBox("Exception", "Invalid response from server", "danger");
        setIsClosing(false);
        return;
      }

      // Check for error
      if (res.data.error) {
        toastMessageBox("Exception", res.data.error, "danger");
        setIsClosing(false);
        return;
      }

      // Check if output exists
      if (!res.data.output) {
        console.error('No output in response:', res.data);
        // If there's no output but no error, it might still be successful
        toastMessageBox("Successful", "Ticket closed successfully and emails sent", "success");

        // Close modal and reset states
        setShowDeleteConfirm(false);
        setModalShow(false);
        setIdToDelete(null);
        setRemarks('');
        setSelectedResolutionStatus(0);

        setTimeout(() => {
          setIsClosing(false);
          navigate(-1);
        }, 1000);
        return;
      }

      // Extract output safely
      const { outputMessage, responseStatus } = res.data.output;
      console.log('outputMessage:', outputMessage);
      console.log('responseStatus:', responseStatus);

      if (responseStatus === "failed" || responseStatus === "fail") {
        toastMessageBox("Warning", outputMessage || "Failed to close ticket", "warning");

        // Close modal and reset states
        setShowDeleteConfirm(false);
        setModalShow(false);
        setIdToDelete(null);
        setRemarks('');
        setSelectedResolutionStatus(0);
        setIsClosing(false);

        return;
      }

      // Success
      toastMessageBox("Successful", outputMessage || "Ticket closed successfully and emails sent", "success");

      // Close modal and reset states
      setShowDeleteConfirm(false);
      setModalShow(false);
      setIdToDelete(null);
      setRemarks('');
      setSelectedResolutionStatus(0);

      // Small delay before navigation to ensure toast is visible
      setTimeout(() => {
        setIsClosing(false);
        navigate(-1);
      }, 1000);

    } catch (err) {
      console.log('Error closing ticket:', err);
      console.log('Error details:', err.response?.data);
      toastMessageBox("Exception", err.response?.data?.message || err.message || "Failed to close ticket. Please try again.", "danger");
      setIsClosing(false);
    }
  };

  const confirmBanHandler = async () => {
    try {
      setIsBanning(true); // Start loading

      const token = localStorage.getItem('token');
      const userLogId = localStorage.getItem('userData');
      const userId = userLogId ? JSON.parse(userLogId).userId : null;
      const gmtOffset = userLogId ? JSON.parse(userLogId).gmtOffset : null;

      setBanIdToDelete(ticketMasterId);
      console.log('confirmBanHandler called with:', companyMasterId, token, gmtOffset, userId);
      console.log(token, gmtOffset, userLogId, banIdToDelete);

      const res = await active_inative(banIdToDelete, token, gmtOffset, userId);
      console.log('res.data:', res.data);

      if (res.data && res.data.error) {
        toastMessageBox('Exception', res.data.error, 'danger');
        setShowBanConfirm(false);
        setIsBanning(false);
        return;
      }

      toastMessageBox('Success', 'Client banned and deleted successfully.', 'success');
      setShowBanConfirm(false);

      // Small delay before navigation
      setTimeout(() => {
        setIsBanning(false);
        navigate(-1);
      }, 1000);

    } catch (err) {
      console.log('Error banning client:', err);
      toastMessageBox('Exception', 'Failed to ban visitor.', 'danger');
      setShowBanConfirm(false);
      setIsBanning(false);
    }
  };

  useEffect(() => {
    // If companyMasterId1 is passed as a prop, use it. Otherwise, fetch from backend.
    if (companyMasterId1) {
      setCompanyMasterId(companyMasterId1);
      console.log('useEffect: set companyMasterId from prop:', companyMasterId1);
      loadDrpResolutionStatus();
    } else {
      const fetchData = async () => {
        console.log('ticketMasterId!', ticketMasterId);
        const token = localStorage.getItem('token');
        const obj = await getTicketMasterCon(ticketMasterId, token);
        if (obj && obj.CompanyMasterId) {
          setCompanyMasterId(obj.CompanyMasterId);
          console.log('useEffect: set companyMasterId from backend:', obj.CompanyMasterId);
        }
        loadDrpResolutionStatus();
      };
      fetchData();
    }
  }, [companyMasterId1, ticketMasterId]);

  useEffect(() => {
    console.log('companyMasterId changed:', companyMasterId);
  }, [companyMasterId]);

  const loadDrpResolutionStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await getDrpResolutionStatus(token);
      const data = res.data;
      const options = [{ value: '', text: 'Select' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setResolutionStatus(options);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <CustomModal
        show={modalShow}
        onHide={() => {
          if (!isClosing) { // Prevent closing modal while processing
            setModalShow(false);
            setRemarks('');
            setSelectedResolutionStatus(0);
          }
        }}
        heading="Close Ticket"
      >
        <div className='text-center'>
          <div className="mb-2 text-start">
            <Form.Label className="mb-1 mt-2 fs--1">
              Resolution Status <span className="text-danger">*</span>
            </Form.Label>
            <SelectOption
              size="sm"
              options={resolutionStatus}
              handleChange={e => {
                setSelectedResolutionStatus(
                  e.target.value === '' ? null : e.target.value
                );
              }}
              selectedValue={selectedResolutionStatus}
              disabled={isClosing}
            />
            {(!selectedResolutionStatus || selectedResolutionStatus === 0) && (
              <small className="text-muted">Please select a resolution status</small>
            )}
          </div>

          <div className="mb-2 text-start">
            <Form.Label className="mb-1 mt-2 fs--1">Remarks</Form.Label>
            <textarea
              className="form-control"
              rows="4"
              placeholder="Add remarks here..."
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
              disabled={isClosing}
            />
          </div>

          <IconButton
            variant="success"
            size="md"
            icon={isClosing ? "" : "check"}
            transform="shrink-2"
            iconAlign="middle"
            className="mx-2"
            onClick={() => {
              setIdToDelete(ticketMasterId);
              setShowDeleteConfirm(true);
            }}
            disabled={isClosing || !selectedResolutionStatus || selectedResolutionStatus === 0}
          >
            {isClosing ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-1"
                />
                Closing...
              </>
            ) : (
              <span className="d-none d-md-inline-block ms-1">Close Ticket</span>
            )}
          </IconButton>
        </div>
      </CustomModal>

      {showBanConfirm && (
        <DeleteConfirm
          title="Confirm Ban Visitor"
          message="Do you really want to ban and delete this client?"
          onConfirm={confirmBanHandler}
          onCancel={() => {
            if (!isBanning) {
              setShowBanConfirm(false);
            }
          }}
          isLoading={isBanning}
        />
      )}

      <Card>
        {showDeleteConfirm && (
          <DeleteConfirm
            title="Confirm Close"
            message="Do you really want to close this ticket? Emails will be sent to all recipients."
            onConfirm={confirmCloseHandler}
            onCancel={cancelCloseHandler}
            isLoading={isClosing}
          />
        )}

        <Card.Header className="d-flex flex-between-center">
          <IconButton
            onClick={() => navigate(-1)}
            variant="falcon-default"
            size="sm"
            icon="arrow-left"
            disabled={isClosing || isBanning}
          />
          <Flex>
            <IconButton
              variant="falcon-default"
              size="sm"
              icon="object-ungroup"
              transform="shrink-2"
              iconAlign="middle"
              disabled={isClosing || isBanning}
            >
              <span className="d-none d-md-inline-block ms-1">Merge</span>
            </IconButton>
            <IconButton
              variant="falcon-default"
              size="sm"
              icon="check"
              transform="shrink-2"
              iconAlign="middle"
              className="mx-2"
              onClick={() => { setModalShow(true); }}
              disabled={isClosing || isBanning || (!isAccepted && assignedAgent !== currentUserName)}
            >
              <span className="d-none d-md-inline-block ms-1">close</span>
            </IconButton>
            <IconButton
              variant="danger"
              size="sm"
              icon="ban"
              transform="shrink-2"
              iconAlign="middle"
              onClick={() => {
                setBanIdToDelete(ticketMasterId);
                setShowBanConfirm(true);
              }}
              disabled={isClosing || isBanning}
            >
              <span className="d-none d-md-inline-block ms-1">Blocked</span>
            </IconButton>
          </Flex>
        </Card.Header>
      </Card>
    </>
  );
};

export default TicketsPreviewHeader;